// Brand identity
import aksaStudioLogo from '../../assets/images/logo-full.svg'
import aksaIcon from '../../assets/images/logo.png'

// images
import loginImage from '../../assets/images/background/grandmother-mother-and-daughter-smilling-and-laughing-on-beach.jpg'
import dashBoardImage from '../../assets/images/dashboard.jpg'

// shapes
import arrowLeft from '../../assets/images/shape/arrow.svg'

// menu
import dashboard from '../../assets/images/dashboard/dashboard.svg'
import orgChartImage from '../../assets/images/dashboard/user-access-management-1.svg'

// chatBot
import auraLogoIcon from '../../assets/images/aura-icon.svg'
import auraLogo from '../../assets/images/aura.svg'
import nvsChatbotIcon from '../../assets/images/nvs-chatbot-icon.svg'

const AssetPath = {
  image: {
    loginImage,
    dashBoardImage
  },
  brand: {
    aksaIcon,
    aksaStudioLogo,
    auraLogo,
    auraLogoIcon,
    nvsChatbotIcon
  },

  shape: {
    arrowLeft
  },
  menu: {
    dashboard,
    orgChartImage
  }
}

export default AssetPath
